import React from 'react';
import './OrderPage.css';

import { PageTitle } from '../../../components';
import { Order } from '../../../sections';



const OrderPage = () => {

  return (

    <div className='order-page'>

      {/* Page Title */}
      <PageTitle title={'Order Now'} page={'Order Now'} />

      {/* Order Form */}
      <Order />

    </div>

  );

}

export default OrderPage;